import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { FlaskConical } from "lucide-react";
import { API } from "./shared";

export function AcTestAccounts() {
  const [q, setQ] = useState("");
  const [onlyTest, setOnlyTest] = useState(false);
  const [data, setData] = useState(null);
  const load = () => axios.get(`${API}/admin/test-accounts`, { params: { q, only_test: onlyTest } }).then(r => setData(r.data)).catch(() => setData({ users: [] }));
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [q, onlyTest]); // eslint-disable-line react-hooks/exhaustive-deps
  const toggle = async (u) => {
    try {
      await axios.patch(`${API}/admin/users/${u.id}/test-account`, { is_test: !u.is_test_account });
      toast.success(`${u.email} ${u.is_test_account ? "is now a real account" : "marked as test account"}`);
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Could not update"); }
  };
  return (
    <div className="ac-panel" data-testid="ac-test-accounts">
      <header className="ac-panel-head">
        <b style={{ display: "inline-flex", alignItems: "center", gap: 6 }}><FlaskConical size={15}/> Test accounts</b>
        <div className="ac-controls" style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <input data-testid="test-acc-search" placeholder="Search email, name, company" value={q} onChange={e => setQ(e.target.value)}
            style={{ border: "1px solid #CBD5E1", borderRadius: 7, padding: "6px 9px", fontSize: 12, minWidth: 220 }}/>
          <label style={{ fontSize: 12, display: "flex", gap: 5, alignItems: "center", cursor: "pointer" }}>
            <input data-testid="test-acc-only" type="checkbox" checked={onlyTest} onChange={e => setOnlyTest(e.target.checked)}/> Only test
          </label>
        </div>
      </header>
      <p style={{ fontSize: 12.5, color: "#64748b", margin: "0 0 12px" }}>
        Orders where the buyer or the awarded supplier is a test account never book a real Shiprocket shipment. Dispatch creates a dummy TEST AWB instead.
        {data && <> Shiprocket bookings in this environment: <b data-testid="test-acc-sr-status" style={{ color: data.shiprocket_orders_enabled ? "#047857" : "#B45309" }}>{data.shiprocket_orders_enabled ? "ON (live)" : "OFF (all simulated)"}</b>.</>}
      </p>
      {!data ? <div style={{ fontSize: 13 }}>Loading…</div> : (
        <table style={{ width: "100%", fontSize: 12.5, borderCollapse: "collapse" }}>
          <thead><tr style={{ background: "#f3f4f6", textAlign: "left" }}>
            {["User", "Role", "Test account"].map(h => <th key={h} style={{ padding: "8px 10px", fontSize: 11 }}>{h}</th>)}
          </tr></thead>
          <tbody>{data.users.map(u => (
            <tr key={u.id} data-testid={`test-acc-row-${u.id}`} style={{ borderBottom: "1px solid #e5e7eb" }}>
              <td style={{ padding: "8px 10px" }}><b>{u.company || u.name}</b><div style={{ fontSize: 11, color: "#64748b" }}>{u.email}</div></td>
              <td style={{ padding: "8px 10px" }}>{u.role}</td>
              <td style={{ padding: "8px 10px" }}>
                <label style={{ display: "flex", gap: 6, alignItems: "center", cursor: "pointer" }}>
                  <input data-testid={`test-acc-toggle-${u.id}`} type="checkbox" checked={!!u.is_test_account} onChange={() => toggle(u)}/>
                  {u.is_test_account ? <span style={{ color: "#B45309", fontWeight: 700 }}>TEST</span> : <span style={{ color: "#64748b" }}>Real</span>}
                </label>
              </td>
            </tr>))}
            {data.users.length === 0 && <tr><td colSpan={3} style={{ padding: 14, color: "#64748b" }}>No users found.</td></tr>}
          </tbody>
        </table>
      )}
    </div>
  );
}

export const IncludeTestToggle = ({ value, onChange, count, testid }) => (
  <label data-testid={testid} title="Orders where the buyer or supplier is a test account" style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 11.5, fontWeight: 600, color: value ? "#B45309" : "#64748b", cursor: "pointer", whiteSpace: "nowrap" }}>
    <input data-testid={`${testid}-input`} type="checkbox" checked={value} onChange={e => onChange(e.target.checked)} style={{ width: "auto" }}/>
    Include test orders{count ? ` (${count})` : ""}
  </label>
);
